import React, {useCallback, useState} from 'react'
import {Tabs, Tab, Box} from '@mui/material'
import DialogHeader from "@/view/layout/DialogHeader";
import HeaderSpacer from "@/view/layout/HeaderSpacer";
import GameEditTab from "@/view/game/GameEditTab";
import {GameItem} from "@/service/GameService";
import GamePlayersTab from "@/view/game/GamePlayersTab";
import GameResultTab from "@/view/game/GameResultTab";
import OperationTab from "@/view/game/OperationTab"

export interface GameDetailParam {
    onClose: () => void,
    onReturn: () => void,
    game: GameItem
}

const GameDetail = (props:GameDetailParam) => {

    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])
    const handleReturnClick = useCallback(() => {
        props.onReturn()}, [props.onReturn])

    const [tabIndex, setTabIndex] = useState(0)

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue)
    }

    return (
        <>
            <DialogHeader title="Match" onClose={handleOverlayClick} leftIcon={'prev-w w-8 w-17'}/>

            <div className="game-detail">
                <HeaderSpacer />

                {/* 탭 영역 */}
                <Tabs
                    value={tabIndex}
                    onChange={handleChange}
                    variant="fullWidth"
                    className="game-detail-tabs"
                >
                    <Tab label="Match" />
                    <Tab label="참가자" />
                    <Tab label="작전판" />
                    <Tab label="결과" />
                </Tabs>

                {/* 탭 컨텐츠 */}
                <Box className="game-detail-content">
                    {tabIndex === 0 && (
                        <div>
                            <GameEditTab
                                game={props.game}
                                onClose={props.onClose}
                                onReturn={handleReturnClick}
                            />
                        </div>
                    )}

                    {tabIndex === 1 && (
                        <div>
                            <GamePlayersTab
                                game={props.game}
                            />
                        </div>
                    )}

                    {tabIndex === 2 && (
                        <div>
                            <OperationTab
                                game={props.game}
                            />
                        </div>
                    )}

                    {tabIndex === 3 && (
                        <div>
                            <GameResultTab
                                game={props.game}
                                onClose={props.onClose}
                                onReturn={handleReturnClick}
                            />
                        </div>
                    )}
                </Box>
            </div>
        </>
    )
}

export default GameDetail
